import React, { useState } from 'react';

const WhatsAppOverlay = () => {
  const [showOverlay] = useState(false);

  return (
    <div className="overlay-container">
      <a
        href="https://api.whatsapp.com/send?phone=919975340919&text=Hello,%20I%20came%20from%20your%20website"
        className="whatsapp-toggle-button"
        title="Chat with us on WhatsApp"
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <img src="/whatsapp.png" alt="WhatsApp" />
      </a>
      {showOverlay && (
        <div className="whatsapp-overlay">
          <p>Click to chat on WhatsApp</p>
        </div>
      )}
      {/* INLINE CSS */}
      <style>{`
        .overlay-container {
          position: relative;
        }
        
        .whatsapp-toggle-button {
          position: fixed;
          bottom: 26px;
          right: 98px;
          z-index: 99998;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
          transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
          text-decoration: none;
        }
        
        .whatsapp-toggle-button:hover {
          transform: scale(1.08) translateY(-2px);
          box-shadow: 0 8px 22px rgba(37, 211, 102, 0.45);
        }

        .whatsapp-toggle-button:active {
          transform: scale(0.96);
        }

        .whatsapp-toggle-button img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          display: block;
          object-fit: cover;
        }
        
        .whatsapp-overlay {
          position: fixed;
          bottom: 92px;
          right: 98px;
          background-color: #fff;
          border: 1px solid #ccc;
          padding: 10px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          z-index: 99998;
          font-family: sans-serif;
          font-size: 13px;
        }
        
        @media (max-width: 480px) {
          .whatsapp-toggle-button {
            bottom: 22px;
            right: 86px;
            width: 50px;
            height: 50px;
          }
          .whatsapp-toggle-button img {
            width: 50px;
            height: 50px;
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppOverlay;